import React from "react";
import { Paper, Typography } from "@mui/material";
import MuiPieChart from "./MuiPieChart.tsx";

const SourcePieChart = () => {
  const sourceData = [
    { id: 1, value: 45, label: "Organic" },
    { id: 2, value: 30, label: "Paid Ads" },
    { id: 3, value: 15, label: "Referral" },
    { id: 4, value: 10, label: "Email" },
  ];

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>Leads by Source</Typography>
      <MuiPieChart data={sourceData} />
    </Paper>
  );
};

export default SourcePieChart;